import React from 'react';
import { HeartIcon } from '@heroicons/react/24/outline';
import { StarIcon, StarIcon as StarIconSolid } from '@heroicons/react/24/solid';
import edit from "../assets/icons/pencil-01.svg";
import share from "../assets/images/share.svg";

interface Restaurant {
  name: string;
  rate?: number;
  category: string;
}

interface RestaurantHeaderProps {
  restaurant: Restaurant;
  onWriteCommentClick?: () => void;
}

const StarRating = ({ rating }: { rating: number }) => {
  return (
    <div className="flex justify-between items-center">
      <span className="font-myYekanFaNumMedium text-sm sm:text-base">{rating}</span>
      <div className="flex items-center ml-1">
         <StarIconSolid className="h-4 w-4 sm:h-5 sm:w-5 text-green-600" />
      </div>
    </div>
  );
};

const RestaurantHeader: React.FC<RestaurantHeaderProps> = ({ restaurant,  onWriteCommentClick }) => {
  return (
    <div className="mb-3 font-myYekanFaNumRegular">
      <div className="flex flex-row flex-row justify-between sm:items-center gap-1">
        <div className='flex flex-row justify-between items-center'>
          <h1 className="desktop:text-3xl tablet:text-2xl text-[18px] text-black font-myYekanDemibold">
            {restaurant.name}
          </h1>
          <div className="flex mr-3 text-xs sm:text-lg">
            {restaurant.rate && <StarRating rating={restaurant.rate} />}
          </div>
        </div>

        <div className="flex items-center justify-end space-x-1 space-x-reverse text-xs sm:text-sm font-myYekanFaNumMedium">
          <button className="flex items-center text-black px-1 sm:px-2 py-1">
            <img src={share} alt="اشتراک گذاری" className='w-[20px] h-[20px] sm:w-[32px] s:h-[32px] ml-1' />
            <span className='hidden sm:block'>اشتراک گذاری</span>
          </button>

          <button onClick={onWriteCommentClick} className="flex items-center text-black px-1 sm:px-2 py-1" >
            <img src={edit} alt="ثبت نظر" className='w-[20px] h-[20px] sm:w-[32px] s:h-[32px] ml-1' />
            <span className='hidden sm:block'>ثبت نظر</span>
          </button>

          <button className="flex items-center text-black">
            <HeartIcon className="hidden sm:block md:block w-[24px] h-[24px] sm:w-[32px] s:h-[32px] ml-1" />
            <span className='hidden sm:block md:block'>افزودن به علاقه‌مندی‌</span>
          </button>

          <button className="flex items-center text-black">
            <HeartIcon className="hidden w-[24px] h-[24px] sm:w-[32px] s:h-[32px] ml-1" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantHeader;